import React, {  useState } from 'react';
import { GalleryVideo } from "../../Components";
import {
  trashGalleryIcon,
} from "../../Components";
import { Eye, EyeOff } from 'lucide-react';

export default function GalleryGridItem(props) {
  const [showActionIcon, setShowActionIcon] = useState(false);

  return (
    <div 
      className="group relative bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden border border-slate-200"
      onMouseEnter={() => setShowActionIcon(true)}
      onMouseLeave={() => setShowActionIcon(false)}
    >
      {/* Status Indicator */}
      <div className={`absolute top-4 left-4 z-10 px-3 py-1 rounded-full text-xs font-medium ${
        props.status === 'visible' 
          ? 'bg-emerald-100 text-emerald-800 border border-emerald-200' 
          : 'bg-slate-100 text-slate-600 border border-slate-200'
      }`}>
        {props.status === 'visible' ? 'Visible' : 'Hidden'}
      </div>

      {/* Action Icons */}
      <div className={`absolute top-4 right-4 z-10 flex flex-col gap-2 transition-all duration-300 ${
        showActionIcon ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4'
      }`}>
        {props.status === 'visible' && (
          <button 
            onClick={() => props.confirmHide(props.id)}
            className="bg-white hover:bg-slate-50 text-slate-700 p-2  rounded-lg shadow-sm border border-slate-200 hover:border-slate-300 transition-colors duration-200 "
            title="Hide image"
          >
            <EyeOff size={16} color="#4dd576" className='items-center'/>
          </button>
        )}
        {props.status === 'hide' && (
          <button 
            onClick={() => props.confirmShow(props.id)}
            className="bg-white hover:bg-slate-50 text-slate-700 p-2 rounded-lg shadow-sm border border-slate-200 hover:border-slate-300 transition-colors duration-200"
            title="Make visible"
          >
           <Eye size={16} color="#4dd576" />
          </button>
        )}
        <button 
          onClick={() => props.confirmDelete(props.id)}
          className="bg-white hover:bg-red-50 text-red-600 p-2 rounded-lg shadow-sm border border-red-200 hover:border-red-300 transition-colors duration-200"
          title="Delete image"
        >
          {trashGalleryIcon}
        </button>
      </div>

      {/* Image/Video Container */}
      <div className="assetsItem__inner">
        <div className="assetsItem__header-media relative">
          {props.media_type_id === 2 && (
            <div className="relative overflow-hidden bg-slate-100">
              <img 
                src={process.env.PUBLIC_URL + props.thumbnail_url} 
                alt={props.thumbnail_url} 
                className={`w-full aspect-square object-cover transition-transform duration-700 group-hover:scale-105 ${
                  props.status === "hide" ? "filter grayscale" : ""
                }`} 
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
            </div>
          )}
          {props.media_type_id === 1 && (
            <GalleryVideo setShowActionIcon={setShowActionIcon} {...props} />
          )}
        </div>
      </div>

      {/* Footer */}
      <div className="p-4 border-t border-slate-100">
        <div className="flex justify-between items-center text-sm">
          <span className="text-slate-600 font-medium">ID: {props.id}</span>
          <div className={`w-2 h-2 rounded-full ${
            props.status === 'visible' ? 'bg-emerald-500' : 'bg-slate-400'
          }`}></div>
        </div>
      </div>
    </div>
  );
}